import { combineReducers } from "redux";

import cloudReducer from "./containers/HomePage/reducer";

export default combineReducers({
    clouds: cloudReducer,
});
